import { render, staticRenderFns } from "./PrivacyPolicies.html?vue&type=template&id=e20ae42c&scoped=true&"
import script from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicies.scss?vue&type=style&index=0&id=e20ae42c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ae42c",
  null
  
)

export default component.exports